import Pagination from '@mui/material/Pagination';
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { DateRangePicker, createStaticRanges, defaultStaticRanges } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import { BsFilterLeft } from "react-icons/bs";
import { FaEllipsisV } from "react-icons/fa";
import { PiArrowsDownUpFill } from "react-icons/pi";
import DeleteConformation from "../../components/common/modals/DeleteConformation";
import SearchInput from "../../components/ui/SearchInput";
import { fetchImages } from "../../constants/HandleImages";
import { ErrorMessages } from "../../constants/Labels";
import { deleteSearchLog, getSearchLogList } from '../../services/AuthService';
import { convertTo24HourFormat, formatDates, formatTimestamp } from "../../utils/common/Format";
import { showToastError, showToastSuccess } from "../../utils/common/ToastMessages";
import SearchMetrics from './SearchMetrics';


export default function SearchLogList() {
  const options = [
    { value: '0', label: 'All' },
    { value: '1', label: 'Successful Searches' },
    { value: '2', label: 'Zero Result Searches' },
    { value: '3', label: 'Searches With Low Results' },
    { value: '4', label: 'Searches With High Results' },
    //  { value: '5', label: 'By Date' },

  ];
  const metricsFilters = [
    { value: 'All Time', label: 'All Time' },
    { value: 'Last week', label: 'Last week' },
    { value: 'Last month', label: 'Last month' },
    { value: 'Last 3 months', label: 'Last 3 months' },
    { value: 'Last 6 months', label: 'Last 6 months' },
    { value: 'Last year', label: 'Last year' },

  ];
  const [deleteItem, setDeleteItem] = useState()
  const [deletePopup, setShowDeletePopup] = useState(false)
  const [tipDetials, setshowTipDetails] = useState(false)
  const [selectedItem, setSelectedItem] = useState()
  const [pageNumber, setPageNumber] = useState(1);
  const [selectedListType, setSelectedListType] = useState('searchLog')
  const dropdownRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [actionIndex, setActionIndex] = useState<number | null>(null);
  const [totalCount, setTotalCount] = useState(0);
  const recordsPerPage = 10; // Number of records per page
  const [selectedOption, setSelectedOption] = useState<any>('');
  const [showCalendar, setShowCalendar] = useState(false);
  const [startDate, setStartDate] = useState<any>('');
  const [endDate, setEndDate] = useState<any>('');
  const [dates, setDate] = useState<any>()
  const [sortValue, setSortValue] = useState('')
  const [orderByDateTime, setOrderByDateTime] = useState<any>('Asc');
  const [searchLogData, setSearchLogData] = useState([])
  const [orderBySearchTerm, setOrderBySearchTerm] = useState('Asc')
  const [orderBySynonym, setOrderBySynonym] = useState('Asc')
  const [orderByUserType, setOrderByUserType] = useState('Asc')
  const [orderByFrequency, setOrderByFrequency] = useState('Asc')
  const [orderBy, setOrderBy] = useState('Asc')
  const [selectedMetricsSortOption, setSelectedMetricsSortOption] = useState<any>('All Time');
  const [showMetricsCalender, setShowMetricsCalender] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [tempStartDate, setTempStartDate] = useState<any>(null);
  const [tempEndDate, setTempEndDate] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);




  // To clear activity popup
  const clearActivityPopup = useCallback(() => {
    setActionIndex(null);
  }, []);
  // handle clikoutside action popup
  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (dropdownRefs.current.some((ref) => ref && ref.contains(event.target as Node))) {
      return;
    }
    clearActivityPopup();
  }, [clearActivityPopup]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);
  // To open actions 
  const OpenActionArea = (index: number) => {
    setActionIndex(index);
  };
  // Delete conform popup open 
  const deleteConform = (item: any) => {
    setDeleteItem(item)
    setShowDeletePopup(true)
  }
  // success handle for delete
  const successHandle = () => {
    let obj = {
      "searchId": deleteItem
    }
    deleteSearchLog(obj).then((response: any) => {
      if (response.status) {
        showToastSuccess(response.message)
        getSearchLogListData();
        setShowDeletePopup(false)
      } else {
        showToastSuccess(response.message)
      }

    }).catch(() => {
      showToastError(ErrorMessages.SomethingWrong)
      setShowDeletePopup(false)
    })
  }

  // To send the utcoff set time
  const getUTCOffset = () => {
    const date = new Date();
    const offsetInMinutes = date.getTimezoneOffset();
    const offsetHours = Math.floor(Math.abs(offsetInMinutes) / 60);
    const offsetMinutes = Math.abs(offsetInMinutes) % 60;
    const sign = offsetInMinutes <= 0 ? '+' : '-';
    return `${sign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`;
  };
  // TO get the list data
  const getSearchLogListData = () => {
    setIsLoading(true)
    const utcOffset = getUTCOffset()
    let obj = {
      "pageNumber": pageNumber,
      "pageSize": 10,
      'filterType': selectedOption,
      // "startDate": startDate ? startDate : '',
      // "endDate": endDate ? endDate : '',
      "sortColumnName": sortValue,
      "sortColumnDirection": orderBy,
      // "utcOffset": (startDate && endDate !== '' ? utcOffset : ''),
      // "category": searchTerm,
    }
    getSearchLogList(obj).then((response: any) => {
      // if (response?.status) {
      setSearchLogData(response.searchLog?.searchLogData)
      setTotalCount(response?.searchLog?.totalCount);
      // } else {
      //   showToastError(response?.message)
      // }

    }).catch(() => {
      showToastError(ErrorMessages?.SomethingWrong)
    }).finally(() => setIsLoading(false))
  }

  // Dropdown selections of dates
  const handleSelect = (date: any) => {
    const startDate = moment(date.selection.startDate).startOf('day').format('YYYY-MM-DD');
    const endDate = moment(date.selection.endDate).startOf('day').format('YYYY-MM-DD');
    setDate(date)
    setTempStartDate(startDate);
    setTempEndDate(endDate);
  };

  const selectionRange = {
    startDate: moment(tempStartDate).toDate(),
    endDate: moment(tempEndDate).toDate(),
    key: 'selection',
  };
  // To add custum filter to calender
  const customStaticRanges = createStaticRanges([
    ...defaultStaticRanges,
    {
      label: 'Custom',
      range: () => ({
        startDate: new Date(),
        endDate: new Date(),
      }),
      isSelected(range: any) {
        return range.custom;
      },
    },
  ]);

  // custum selected dates submit
  const setCustumDates = () => {
    let SDates = moment(dates?.selection?.startDate).startOf('day').format('YYYY-MM-DD');
    let EDates = moment(dates?.selection?.endDate).startOf('day').format('YYYY-MM-DD');
    setStartDate(SDates);
    setEndDate(EDates);
    setShowCalendar(false)

  }
  // cancel the selected dates
  const resetTime = () => {
    setStartDate(" ")
    setEndDate(" ")
    setShowCalendar(false)
    setShowMetricsCalender(false)
  }
  const handleDropdownClick = (event: any) => {
    if (!event.target.closest('.smart-date-picker')) {
      if (showCalendar || showMetricsCalender) {
        setShowCalendar(false);
        setShowMetricsCalender(false)
        setStartDate('');
        setEndDate('');
      }
    }
  };
  // Handle change for dropdown selection
  const handleChange = (event: any) => {
    setPageNumber(1)
    setSearchTerm('')
    const value = event.label;
    if (value == 'By Date') {
      setTimeout(() => {
        setShowCalendar(true)
        setSelectedOption(value)
        setTempStartDate(new Date())
        setTempEndDate(new Date())
      }, 500)

    } else {
      setSelectedOption(value);
      setShowCalendar(false)
      setStartDate('')
      setEndDate('')
      setSortValue('')
    }
  };
  useEffect(() => {
    getSearchLogListData();
  }, [pageNumber, orderBy, selectedOption, searchTerm, startDate, endDate]);

  // Pagination
  const handlePageChange = (_event: any, value: any) => {
    setPageNumber(value);
  };
  const totalPages = Math.ceil(totalCount / recordsPerPage);

  // To set tab options
  const listMethod = (listMethod: any) => {
    setSelectedListType(listMethod)
  }

  //set sorting Order of all table values  
  const toggleOrder = (type: 'searchTerm' | 'synonym' | 'userType' | 'frequency' | 'dateTime') => {
    if (type === 'searchTerm') {
      const newOrder = orderBySearchTerm === 'Asc' ? 'Desc' : 'Asc';
      setOrderBySearchTerm(newOrder);
      setSortValue('SearchKey')
      setOrderBy(newOrder)
    }
    else if (type === 'userType') {
      const newOrder = orderByUserType === 'Asc' ? 'Desc' : 'Asc';
      setOrderByUserType(newOrder);
      setSortValue('UserType')
      setOrderBy(newOrder)
    } else if (type === 'frequency') {
      const newOrder = orderByFrequency === 'Asc' ? 'Desc' : 'Asc';
      setOrderByFrequency(newOrder);
      setSortValue('Frequency')
      setOrderBy(newOrder)
    }
    else if (type === 'dateTime') {
      const newOrder = orderByDateTime === 'Asc' ? 'Desc' : 'Asc';
      setOrderByDateTime(newOrder);
      setSortValue('SearchDate')
      setOrderBy(newOrder)
    }
  };

  // Metrics filter handle change
  const metricsHandleChange = (event: any) => {
    const value = event.value
    setSelectedMetricsSortOption(value); // Set the entire event object
  }
  // Searchfunctionality
  const handleSearch = (value: any) => {
    setSearchTerm(value);
  };
  const handleSearchLog = () => {
    listMethod('searchLog');
    setPageNumber(1);
    setSelectedOption('');
    setShowCalendar(false);
    setSearchTerm('');
    setSortValue('')
    getSearchLogListData()
  }
  const handleMetrics = () => {
    listMethod('metrics');
    setSelectedMetricsSortOption('');
    setStartDate(''); setEndDate('');
    setShowMetricsCalender(false);
    setSortValue('')
  }
  return (
    <>
      <div className="container-fluid  px-3">
        {!tipDetials &&
          <div>
            <div className="d-flex justify-content-between align-items-center shadow-sm bg-white rounded border p-3" >
              <h3 className="fw-bold mb-0">Search Analytics </h3>
            </div>
            <div className="d-flex justify-content-between  my-3 bg-white rounded p-2 resourcelist-tab-panel">
              <div className="d-flex justify-content-end mt-0 align-items-center">
                <div className={` p-3 fs-sm py-2 border text-center me-2 w-[160px] cursor-pointer  rounded ${selectedListType === 'searchLog' ? 'bg-secondary text-white shadow-sm' : ' fw-normal'}`} onClick={handleSearchLog}> Search Log</div>
                <div className={`p-3  fs-sm py-2 border text-center w-[160px] cursor-pointer rounded  ${selectedListType === 'metrics' ? ' bg-secondary text-white shadow-sm' : ' fw-normal'}`} onClick={handleMetrics} > Metrics</div>
              </div>
              <div>

              </div>
              {selectedListType == 'searchLog' ?
                <div className="d-flex justify-content-end mt-0 align-items-center">
                  <div className="me-2">
                    {/* <SearchInput label='Search' onChange={handleSearch} value={searchTerm} /> */}
                  </div>
                  <div className="position-relative smart-dropdown" onClick={handleDropdownClick} style={{ maxWidth: '265px' }}>
                    <Dropdown options={options} onChange={handleChange} value={selectedOption} placeholder="Filter" />
                    <BsFilterLeft className="position-absolute start-0 top-50 translate-y-[-50%] text-gray ms-2" />

                    {/* <div style={{ zIndex: '99999' }} className="position-fixed  smart-date-picker deep-shadow bg-white p-0 rounded border mt-[6px]">
                      {showCalendar && (
                        <div className="" style={{ display: 'contents' }}>
                          <DateRangePicker
                            ranges={[selectionRange]}
                            onChange={handleSelect}
                            moveRangeOnFirstSelection={false}
                            staticRanges={customStaticRanges}
                            inputRanges={[]} // Remove predefined input ranges
                            showMonthArrow={true}
                          />
                          <div className="d-flex justify-content-center position-absolute bottom-0 end-0 py-2  pr-3">
                            <button className="btn btn-primary-outline py-1 h-[30px] d-inline-block leading-6" onClick={resetTime}>Cancel</button>
                            <button className="btn btn-primary text-white py-1  ms-2  h-[30px] d-inline-block  leading-6" onClick={setCustumDates}>Submit</button>
                          </div>
                        </div>
                      )}
                    </div> */}
                  </div>
                </div>
                : <div className="smart-dropdown position-relative" onClick={handleDropdownClick}>
                  <Dropdown options={metricsFilters} onChange={metricsHandleChange} value={selectedMetricsSortOption} placeholder="Filter" />
                  <BsFilterLeft className="position-absolute start-0 top-50 translate-y-[-50%] text-gray ms-2" />
                </div>
              }

            </div>
            {selectedListType == 'searchLog' && (
              isLoading ? (
                <div className="d-flex justify-content-center align-items-center bg-white rounded shadow-sm border" style={{ minHeight: 300 }}>
                  <img src={fetchImages.loader} alt="Loading..." style={{ width: 50, height: 'auto' }} />
                </div>
              ) : <>
                <div className="smart-table overflow-x-auto shadow-sm border rounded mxh-calc-321 table-datat-mw-140">
                  <table className="table position-relative my-0">
                    <thead>
                      <tr className="fw-bold  sticky top-0 z-[9]">
                        <th scope="col" className="w-[330px]">
                          <div onClick={() => toggleOrder('searchTerm')} title={orderBySearchTerm === 'Asc' ? 'Switch to descending order' : 'Switch to ascending order'}>
                            <div className="d-flex align-items-center cursor-pointer">Search Term <PiArrowsDownUpFill className="ms-2 mt-[-4px]" size={15} /> </div>
                          </div>
                        </th>
                        <th className="w-[330px]">Synonym</th>
                        <th scope="col" onClick={() => toggleOrder('userType')} >
                          <div className='d-flex justify-content-start cursor-pointer align-items-center text-nowrap'>
                            <div className="d-flex align-items-center"> User Type <span title={orderByUserType === 'Asc' ? 'Switch to descending order' : 'Switch to ascending order'} className='ms-2'><PiArrowsDownUpFill className="mt-[-4px]" /></span></div>
                          </div>
                        </th>
                        <th scope="col" onClick={() => toggleOrder('frequency')} title={orderByFrequency === 'Asc' ? 'Switch to descending order' : 'Switch to ascending order'}>
                          <div className="d-flex align-items-center  cursor-pointer text-nowrap">Frequency <PiArrowsDownUpFill className="ms-2 mt-[-4px]" size={15} /></div>
                        </th>

                        <th scope="col"><div className='d-flex justify-content-start cursor-pointer align-items-center text-nowrap' onClick={() => toggleOrder('dateTime')}>
                          Date & Time <span title={orderByDateTime === 'Asc' ? 'Switch to descending order' : 'Switch to ascending order'} className='ms-2'><PiArrowsDownUpFill className="mt-[-4px]" /></span>
                        </div></th>
                        {/* <th>Action </th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {searchLogData && searchLogData?.length > 0 ?
                        (searchLogData.map((item: any, index: any) => (
                          <tr key={item?.logId} className={`${searchLogData?.length == 1 ? 'moreoptions-position-fixed' : ''}`}>
                            <td title={item?.SearchKey}>{item?.SearchKey?.length > 35 ? item?.SearchKey?.slice(0, 35) + '...' : item?.SearchKey}</td>
                            <td className="" title={item?.SearchSynonym}>
                              {item?.SearchSynonym?.split(',').slice(0, 2).join(', ')}
                              {item?.SearchSynonym?.split(',')?.length > 2 && ' ...'}
                            </td>
                            <td>{item?.UserType}</td>
                            <td>{item?.Frequency}</td>
                            <td>{formatDates(item?.SearchDate)}</td>
                            {/* <td className="actions-column ">
                              <div className="d-flex justify-content-start align-items-center position-relative" ref={(el: any) => (dropdownRefs.current[index] = el)}>
                                <div className="ml-[20px] cursor-pointer">
                                  <FaEllipsisV className="font-size-10 cursor-pointer" onClick={() => OpenActionArea(index)} />

                                  <div className={`custom-dropdown-menu bg-white position-absolute border ml-[-136px] ml--142 min-w-[145px] shadow-sm mt-[20px] top-0 z-[9] ${actionIndex === index ? '' : 'd-none'}`}>
                                    <div className="dropdown-item cursor-pointer py-2" onClick={() => viewTip(item?.logId)}>View</div>
                                    <div className="dropdown-item cursor-pointer py-2" onClick={() => deleteConform(item?.logId)}>Delete</div>
                                  </div>
                                </div>
                              </div>
                            </td> */}
                          </tr>
                        ))) : <tr>
                          <td colSpan={12}><h6 className="fw-bold mt-3 d-flex justify-content-center">No data found </h6></td>
                        </tr>}
                    </tbody>
                  </table>
                </div>
                {searchLogData && searchLogData?.length > 0 &&
                  <div className="d-flex justify-content-end mt-2 ">
                    <div className="bg-white rounded p-2 shadow-sm z-[99] z-intial">
                      <Pagination
                        count={totalPages}
                        variant="outlined"
                        shape="rounded"
                        page={pageNumber}
                        onChange={handlePageChange}
                        siblingCount={1} // Adjust as necessary
                        boundaryCount={1} // Adjust as necessary
                        showFirstButton
                        showLastButton />
                    </div>
                  </div>
                }

              </>
            )}
          </div>
        }
        {selectedListType == 'metrics' && <SearchMetrics selectedSortOption={selectedMetricsSortOption} />}
        {/* {tipDetials && <ViewContributeTip selectedItem={selectedItem} setshowTipDetails={setshowTipDetails} setpageNumber={setPageNumber} setFilterValue={setSelectedOption} getSearchLogListData={getSearchLogListData} tipStatus={tipStatus} setSearchTerm={setSearchTerm} />} */}
        {deletePopup && <DeleteConformation actionType="Delete" title="Delete Conformation" closeModal={setShowDeletePopup} successHandle={successHandle} />}
      </div>

    </>


  )
}